import * as yup from "yup";

import { rentMonthsBetween } from "ui/components/DateRangeRentPicker";

export const IGNORE_ERROR = "IGNORE";

export const FLEET_VEHICLE_OFFER_RENT_EDIT_FORM_SCHEMA = yup.object().shape({
  // --- RAZDOBLJE NAJMA ---
  // Isto pravilo kao na ugovoru: datumi i trajanje se računaju jedno iz drugoga, ali smiju se
  // i ručno prepisati, pa se prije spremanja provjerava da se nisu razišli.
  rentEndDate: yup
    .date()
    .nullable()
    .test(
      "rent-end-after-start",
      "Završetak najma mora biti nakon početka",
      function (value) {
        const start = this.parent.rentStartDate;
        return !value || !start || new Date(value) > new Date(start);
      }
    ),

  rentDurationMonths: yup
    .number()
    .nullable()
    .min(1, "Trajanje najma mora biti barem 1 mjesec")
    .test(
      "rent-duration-matches-period",
      "Trajanje najma ne odgovara odabranom razdoblju",
      function (value) {
        const { rentStartDate, rentEndDate } = this.parent;
        if (!value || !rentStartDate || !rentEndDate) return true;

        const months = rentMonthsBetween(new Date(rentStartDate), new Date(rentEndDate));
        return Math.abs(months - value) <= 1;
      }
    ),

  contactClientId: yup.string().required('Molimo Vas da odaberete kupca'),
  vehicleId: yup.string().required('Molimo Vas da odaberite vozilo'),
  offerDate: yup.string().required('Molimo Vas da unesite datum ponude'),
  dueDate: yup
    .string()
    .nullable()
    .when("durationDays", {
      is: (durationDays: string) => !durationDays,
      then: schema => schema.required("Unesite datum dospijeća ili broj dana"),
    }),

  // durationDays: yup
  //   .string()
  //   .nullable()
  //   .when("dueDate", {
  //     is: (dueDate: string) => !dueDate,
  //     then: schema => schema.required("Unesite datum dospijeća ili broj dana"),
  //   }),
  items: yup
    .array()
    .required("Stavke su obavezne")
    .test(
      "at-least-one-active-item",
      "Morate dodati barem jednu stavku u ponudu",
      items => Array.isArray(items) && items.some(item => !item?.deleted)
    ),
});
